let wsurl = process.env.VUE_APP_WSURL;
if(wsurl) {
    if(wsurl.indexOf('http') < 0)
         wsurl = `http://${wsurl}${process.env.VUE_APP_WEBMMS_PORT && process.env.VUE_APP_WEBMMS_PORT != 80 ? ':' + process.env.VUE_APP_WEBMMS_PORT : ''}`;
    else
         wsurl = `${wsurl}${process.env.VUE_APP_WEBMMS_PORT && process.env.VUE_APP_WEBMMS_PORT != 80 ? ':' + process.env.VUE_APP_WEBMMS_PORT : ''}`;
}else{
    wsurl = "http://127.0.0.1";
}

const config = {
  "wsurl": window.location.hostname,
  //"wsurl": wsurl.trim(),
  //"wsurl": "https://ws1.ypcloud.com",
  "objstore": ">svc/objc",
  "s3api": "https://s3.ypcloud.com",
  "s3url": "https://s3.ypcloud.com/upload",
  //"objstore": ">h3/RKhoshgoftar/objstore-app",
  "objstoreurl": "https://s3.ypcloud.com",
  "loginurl": "https://account.ypcloud.com/auth/verify/?ReturnURL=https://jboard.ypcloud.com/callback",
  //"loginurl": "https://account.ypcloud.com/auth/verify/?ReturnURL=http://localhost:8099/callback",
  //"logouturl": "https://account.ypcloud.com/auth/logout/?ReturnURL=http://localhost:8099/",
  "logouturl": "https://account.ypcloud.com/auth/logout/?ReturnURL=https://jboard.ypcloud.com/",
  "qname": process.env.VUE_APP_QNAME || 'jboard.tv',
  "track": {
    "enable_track": 1,
    "product": "jboard",
    "brick": "home",
    "track_ddn": process.env.VUE_APP_TRACKDDN || '>hub/log',
    "track_topic": "log://track"
  },


};

export default config;
